import { ApiError } from '@discovr/common';

export const POST_ON_HOLD_CODE = 'POST_ON_HOLD';
export const STAGE_CHANGED_CODE = 'STAGE_CHANGED';
export const HAS_LIVE_CONTENT_CODE = 'HAS_LIVE_CONTENT';
export const NOT_ROLLBACKABLE_CODE = 'NOT_ROLLBACKABLE';
export const STAGE_DISABLED_CODE = 'STAGE_DISABLED';

// Codes meaning the row the admin acted on is stale; the roster is refetched.
export const STALE_ROW_CODES: ReadonlySet<string> = new Set([
  POST_ON_HOLD_CODE,
  STAGE_CHANGED_CODE,
  HAS_LIVE_CONTENT_CODE,
  NOT_ROLLBACKABLE_CODE,
  STAGE_DISABLED_CODE,
]);

export function isStaleRowError(err: unknown): boolean {
  return err instanceof ApiError && STALE_ROW_CODES.has(err.code);
}
